import { Dialog } from 'primereact/dialog';
import './share.component.css';
import { useEffect, useState } from "react";
import QRCode from 'react-qr-code';
import { Button } from 'primereact/button';

export default function ShareComponent() {

    const shareData = {
        title: "Fidelity App",
        text: "Entra anche tu a far parte del mondo di Fidelity",
        url: process.env.REACT_APP_BASE_URL ,
      };
      

      const onShare = async () => {
        try {
            await navigator.share(shareData);
            console.log("shared successfully");
          } catch (err) {
            console.log(`Error: ${err}`);
          }
      }

    useEffect(() => {
        
      });

    return (
        <>
                <div className="text-center font-bold p-3 style-text-share-component" style={{fontSize: '15px'}}> Fai inquadrare con la fotocamera questo QRCode: </div>
                <div style={{ margin: "20px", width: "85%" }}>
                    <QRCode
                    size={256}
                    style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                    value={ process.env.REACT_APP_BASE_URL || ''}
                    viewBox={`0 0 256 256`}
                    className='qrcode_style'
                    />
                </div>
                <div className="text-center font-bold p-3 style-text-share-component" style={{fontSize: '15px'}}> Oppure condividi il collegamento tramite app: </div>
                <div className="text-center font-bold p-3 ">
                    <Button className='text-center mt-2 button-share-popup' onClick={() => onShare()} label=" CONDIVIDI "></Button>
                </div>
                
        </>
    )
}